import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/virtual_users',
  component: Management,
  redirect: '/virtual_users/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/virtual_users/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listVirtualUsers
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/virtual_users/ListTable'),
          meta: {
            auth: Auth.listVirtualUsers,
            tabName: 'all'
          }
        }
      ]
    },
    {
      path: 'new',
      component: () => import('@/views/virtual_users/New'),
      meta: {
        auth: Auth.createVirtualUser
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/virtual_users/Edit'),
      meta: {
        auth: Auth.updateVirtualUser
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/virtual_users/DetailLayout'),
      meta: {
        auth: Auth.showVirtualUser
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/virtual_users/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showVirtualUser
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/virtual_users/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showVirtualUser
          }
        },
        // 订单统计
        {
          path: 'order_statistics',
          component: () => import('@/views/virtual_users/details/OrderStatistics'),
          meta: {
            tabName: 'order_statistics', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showVirtualUser
          }
        },
        // 账单
        {
          path: 'transaction_records',
          component: () => import('@/views/virtual_users/details/TransactionRecords'),
          meta: {
            tabName: 'transaction_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showVirtualUser
          }
        }
      ]
    }
  ]
}
